import {
  FormAnswer,
  FormTemplateQuestion,
  FormTemplateQuestionFieldsKindEnum,
} from 'graphql-common';
import {
  FormTemplateQuestionFieldWithAnswer,
  FormTemplateQuestionWithAnswers,
} from '../types';

const positionValue = (value?: number | null) =>
  typeof value === 'number' ? value : Number.MAX_SAFE_INTEGER;

const sortByPosition = <T extends { position?: number | null }>(
  items: T[] | null | undefined,
): T[] => {
  if (!items || !items.length) return [];
  return [...items].sort(
    (a, b) => positionValue(a.position) - positionValue(b.position),
  );
};

export default function mergeTaskQuestionsWithAnswers(
  questions: FormTemplateQuestion[] | null | undefined,
  answers: FormAnswer[] | null | undefined,
  skipKinds?: FormTemplateQuestionFieldsKindEnum[],
): FormTemplateQuestionWithAnswers[] {
  if (!questions || !questions.length) return [];

  const answersByFieldId = new Map<string, FormAnswer>();
  (answers || []).forEach((answer) => {
    if (answer.fieldId) {
      answersByFieldId.set(answer.fieldId, answer);
    }
  });

  const skipKindsSet = new Set(skipKinds ?? []);

  return sortByPosition(questions).map<FormTemplateQuestionWithAnswers>(
    (question) => {
      const sortedFields = sortByPosition(question.fields)
        .filter((field) => {
          if (!field.kind) return true;
          return !skipKindsSet.has(
            field.kind as FormTemplateQuestionFieldsKindEnum,
          );
        })
        .map<FormTemplateQuestionFieldWithAnswer>((field) => ({
          ...field,
          answer: answersByFieldId.get(field.id) || undefined,
        }));

      return {
        ...question,
        fields: sortedFields,
      };
    },
  );
}
